// Scopes for the public API (docs/spec/modules.md §4, PMU-188): what an organisation's API key or an
// installed app may read. Fine-grained and read-mostly; the catalogue grows with the endpoints.
// Restrictions are never granted by default: a key or app must ask for them by name, and the
// console shows them apart. Some data is never available through the API at all: device and
// signing keys, staff and adult PINs, delegation codes, contact details, accounts and sessions,
// billing, the audit log, other organisations and platform data.

export const SCOPES = {
  "roster:read": { label: "See rooms, children and the adults linked to them (names and relationships only)", sensitive: false },
  "presence:read": { label: "See who is in right now and who has left", sensitive: false },
  "events:read": { label: "See pickups and drop-offs: who, when and how they were verified", sensitive: false },
  "requests:read": { label: "See today's pickup and drop-off requests", sensitive: false },
  "restrictions:read": { label: "See custody restrictions (who must not collect a child)", sensitive: true },
} as const;

export type Scope = keyof typeof SCOPES;
export const isScope = (x: unknown): x is Scope => typeof x === "string" && Object.hasOwn(SCOPES, x);
/** Scopes a new key starts with in the console; sensitive ones are always opt-in. */
export const DEFAULT_SCOPES = (Object.keys(SCOPES) as Scope[]).filter((s) => !SCOPES[s].sensitive);
